
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import userx from '@/store/modules/userx';
import schemax from '@/store/modules/schemax';

import { SoftwareType, ProgramData, Query, Program } from '@/store/models.def';
import uuid from 'uuid';

@Component({
	components: {},
})
export default class ProgramQuery extends Vue {
	@Prop({
		default: {
			file: '',
			query: '',
		},
	})
	public value!: Query;

	public data: Query = {
		file: '',
		query: '',
	};

	@Watch('value')
	public onValueChanged(val: Query, oldVal: Query) {
		if (val !== null) {
			this.data = val;
			const result = this._validfy();
			console.log('value change', result);
			if (result === null) {
				this.$emit('input', null);
			}
		}
	}
	public mounted() {
		let result = null;
		if (this.value) {
			this.data = this.value;
			result = this._validfy();
		}
		if (result === null) {
			this.$emit('input', null);
		}
	}
	public get queryState() {
		const query = this.data.query;
		return (
			query.length > 0 &&
			(query.toUpperCase().indexOf('SELECT') === 0 ||
				query.toUpperCase().indexOf('CREATE GLOBAL TEMPORARY TABLE GOBI') === 0 ||
				query.toUpperCase().indexOf('INSERT INTO GOBI_') === 0)
		);
	}
	protected _onInput() {
		this.$emit('input', this._validfy());
	}
	protected _validfy() {
		if (!this.queryState) {
			return null;
		}
		return this.data;
	}
}
